const s = {
  name: "Magnet",
  dimensions: { width: 37, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36.6 40" style="enable-background:new 0 0 36.6 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26.8,6V0h2v6H26.8z"/>
		<path class="st0" d="M2.8,8h10v17c0,2.8,2.2,5,5,5s5-2.2,5-5V8h10v17c0,8.3-6.7,15-15,15s-15-6.7-15-15V8z M24.8,16v9
			c0,3.9-3.1,7-7,7s-7-3.1-7-7v-9h-6v9c0,7.2,5.8,13,13,13s13-5.8,13-13v-9H24.8z M30.8,14v-4h-6v4H30.8z M4.8,10v4h6v-4H4.8z"/>
		<path class="st0" d="M35,0.4l-4,5l1.6,1.2l4-5L35,0.4z"/>
		<path class="st0" d="M24,6.6l-4-5l1.6-1.2l4,5L24,6.6z"/>
		<path class="st0" d="M6.8,0v6h2V0H6.8z"/>
		<path class="st0" d="M11,5.4l4-5l1.6,1.2l-4,5L11,5.4z"/>
		<path class="st0" d="M0,1.6l4,5l1.6-1.2l-4-5L0,1.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Magnet
};
